module.exports = "https://static.zego.com/_next/static/images/ScooterCombineTwo-b4a1b39b1861ac01faae8905f3899e7a.jpg";